import {
  DELETE_ALL_ALERTS,
  FETCH_ALERT_SUMMARY,
  FETCH_ALERTS,
  RESOLVE_ALERT,
  STORE_ALERT_SUMMARY,
  STORE_ALERTS,
} from '../../constants/alerts';

export const fetchAlerts = (data) => ({
  type: FETCH_ALERTS,
  data,
});

export const storeAlerts = (alertEntries) => ({
  type: STORE_ALERTS,
  alertEntries,
});

// Badge counts only — no alert rows. Polled and pushed; the full list is
// pulled separately when the drawer is actually opened.
export const fetchAlertSummary = (data) => ({
  type: FETCH_ALERT_SUMMARY,
  data,
});

export const storeAlertSummary = (alertSummary) => ({
  type: STORE_ALERT_SUMMARY,
  alertSummary,
});

export const resolveAlert = (data) => ({
  type: RESOLVE_ALERT,
  data,
});

export const deleteAllAlerts = (data) => ({
  type: DELETE_ALL_ALERTS,
  data,
});
